export default {
    chart: {
        animation: false,
        panning: false
    },
    title: {
        text: null
    },
    xAxis: {
        ordinal: false,
        type: 'datetime'
    },
    yAxis: {
        title: {
            text: null
        },
        labels: {
            x: -10,
        }
    },
    tooltip: {
        crosshairs: true,
        shared: true,
        zIndex: 50
    },
    credits: {
        enabled: false
    }
};



// WEBPACK FOOTER //
// ./app/services/charting/presets/base.js